import React from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";
import { Card, CardBody, CardTitle } from "reactstrap";

//redux
import { connect } from "react-redux";

function AboutEvent(props) {
  const location = useLocation();

  return (
    <div>
      <Helmet>
        <title>Sobre Evento | Inteegra Plus</title>
      </Helmet>
      <Card>
        <CardBody>
          <CardTitle>Sobre o evento {location.state.event.title}</CardTitle>
          <Outlet />
        </CardBody>
      </Card>
    </div>
  );
}

const mapStateToProps = (state) => {
  const { events } = state;
  return { events, state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    openEvent: (data, activeScreenName = null) => {
      return dispatch({ type: "OPEN_EVENT_MENU", data, activeScreenName });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AboutEvent);
